var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 2.42147C17.9753 2.27016 17.7362 2.18799 17.4902 2.18799C17.2441 2.18799 17.005 2.27016 16.8109 2.42147L1.09375 14.6769L2.45328 16.3963L4.375 14.8979V28.4374C4.37616 29.0172 4.607 29.5729 5.01698 29.9829C5.42697 30.3929 5.98269 30.6238 6.5625 30.6249H28.4375C29.0173 30.6238 29.573 30.3929 29.983 29.9829C30.393 29.5729 30.6238 29.0172 30.625 28.4374V14.9077L32.5467 16.4062L33.9062 14.6868L18.1694 2.42147ZM19.6875 28.4374H15.3125V19.6874H19.6875V28.4374ZM21.875 28.4374V19.6874C21.8744 19.1074 21.6438 18.5514 21.2337 18.1413C20.8235 17.7311 20.2675 17.5005 19.6875 17.4999H15.3125C14.7325 17.5005 14.1765 17.7311 13.7663 18.1413C13.3562 18.5514 13.1256 19.1074 13.125 19.6874V28.4374H6.5625V13.1927L17.5 4.67241L28.4375 13.2037V28.4374H21.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9f41c90e5aa8ee4ede8be3bc7bc33196.svg";
export { ForwardRef as ReactComponent };